import { Col, Form, Radio, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import appI18n from '../../../../config/i18n';
import { ItemInterface } from '../../../../models/ItemInterface';
import { ContactVisibility } from '../contactCompanies';

interface ContactVisibilityFieldProps {
  /** Prefijo de traducciones del modal que lo usa (new_/detail_contact_modal). */
  i18nPrefix: string;
  companyOptions: ItemInterface[];
  disabled?: boolean;
  companyDisabled?: boolean;
}

function ContactVisibilityField({
  i18nPrefix,
  companyOptions,
  disabled,
  companyDisabled,
}: ContactVisibilityFieldProps) {
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const form = Form.useFormInstance();
  const visibility = Form.useWatch('visibility', form);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} lg={24}>
          <Form.Item
            name="visibility"
            initialValue={'all' as ContactVisibility}
            label={t(`${i18nPrefix}.labels.company`)}
            tooltip={t(`${i18nPrefix}.tooltips.company`)}
          >
            <Radio.Group disabled={disabled}>
              <Radio value="all">
                {t(`${i18nPrefix}.labels.visibility_all`)}
              </Radio>
              <Radio value="filtered">
                {t(`${i18nPrefix}.labels.visibility_filtered`)}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      {visibility === 'filtered' && (
        <Row gutter={24}>
          <Col xs={24} lg={24}>
            <Form.Item
              name="company"
              initialValue={[]}
              rules={[
                {
                  required: true,
                  type: 'array',
                  min: 1,
                  message: t(`${i18nPrefix}.validations.company.required`),
                },
              ]}
            >
              <Select
                style={{ width: '100%' }}
                mode="multiple"
                options={companyOptions}
                disabled={disabled || companyDisabled}
                placeholder={t(`${i18nPrefix}.placeholders.company`)}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </>
  );
}

export default ContactVisibilityField;
